export const PRESETS = [
  { id: "liquid-gold", label: "Liquid Gold", desc: "Warm white, nude & 24k gold", colors: ["#FAF8F5", "#E8D5CE", "#D4AF37"], dark: false },
  { id: "midnight-gold", label: "Midnight Gold", desc: "Dark noir with glowing gold", colors: ["#14100E", "#2C2421", "#D4AF37"], dark: true },
  { id: "rose-quartz", label: "Rose Quartz", desc: "Blush pearl & rose gold", colors: ["#FBF6F5", "#F7E9E9", "#C08089"], dark: false },
  { id: "pearl-aurora", label: "Pearl Aurora", desc: "Cool pearl & iridescent violet", colors: ["#F7F7FA", "#ECE8F5", "#8E7CC3"], dark: false },
  { id: "noir-emerald", label: "Noir Emerald", desc: "Deep green noir & emerald glow", colors: ["#0E1411", "#1C2B24", "#3CB98A"], dark: true },
];

const PRESET_CLASSES = ["theme-midnight", "preset-rose-quartz", "preset-pearl-aurora", "preset-noir-emerald"];

export function applyPreset(id) {
  const p = PRESETS.find((x) => x.id === id) || PRESETS[0];
  const root = document.documentElement;
  root.classList.remove(...PRESET_CLASSES);
  if (p.dark) root.classList.add("theme-midnight");
  if (p.id !== "liquid-gold" && p.id !== "midnight-gold") root.classList.add(`preset-${p.id}`);
  try {
    localStorage.setItem("royal_preset", p.id);
  } catch (e) {}
  return p.id;
}

export function currentPreset() {
  try {
    return localStorage.getItem("royal_preset") || null;
  } catch (e) {
    return null;
  }
}
